export const blockIconsAudioandvideoWeb = (
	<span className='material-symbols-outlined'>web</span>
);
